import { Stack, StackProps } from "@mui/material";
import PrintComponentHeader from "./header"
import PrintComponentTable from "./table";
import PrintComponentCriterias from "./criterias";
import PrintComponentData from "./data";

export default function PrintComponent({
    children,
    ...props
}: StackProps) {
    return <Stack {...props} gap={3} padding={3}>
        {children}
    </Stack>
}

PrintComponent.Header = PrintComponentHeader;
PrintComponent.Table = PrintComponentTable;
PrintComponent.Criterias = PrintComponentCriterias;
PrintComponent.Data = PrintComponentData;